module.exports = __webpack_public_path__ + "static/media/checked.e4d469b1.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/checked.PNG
// module id = 1988
// module chunks = 0